<div class="ap-outcome">
    <div class="ap-outcome-head">
        <span class="ap-outcome-label">{{ section.label }}</span>
        <span
            *ngIf="confidenceLabel as label"
            class="ap-confidence-badge"
            [class.tone-high]="confidence === 'high'"
            [class.tone-review]="confidence === 'review'"
            [class.tone-low]="confidence === 'low'">
            {{ label }}
        </span>
    </div>
    <div class="ap-outcome-effect-row">
        <i class="ph-bold ph-check-circle icon-text icon-18 ap-outcome-check" aria-hidden="true"></i>
        <span class="ap-outcome-effect">{{ effectText }}</span>
    </div>
    <p class="ap-outcome-amount" *ngIf="section.amount">{{ section.amount }}</p>
</div>
